import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CardModule } from 'primeng/card';
import { SkeletonModule } from 'primeng/skeleton';
import { CacheDebugBadgeComponent } from '../../components/common/cache-debug-badge/cache-debug-badge.component';

/**
 * Shell for every customer pre-auth page (login, forgot-password, reset-link,
 * reset-password, reset-password-status).
 *
 * Deliberately does NOT follow a sibling tab's sign-in. Only the login page
 * does (see `LoginComponent`); the four password-reset pages stay where they
 * are so a user mid-reset is not yanked away, and reach the dashboard through
 * their "Back to Login" link, which runs `redirectIfAuthenticatedGuard`.
 */
@Component({
  selector: 'auth-layout',
  imports: [RouterOutlet, NgOptimizedImage ,CardModule, SkeletonModule, CacheDebugBadgeComponent],
  templateUrl: './auth-layout.component.html',
})

export class AuthLayoutComponent {
  isLoadingYYCLogo: boolean = true;
  currentYear: number = new Date().getFullYear();
}
